import { createEffect } from 'effector';
import { SearchResultItem as SplSearchResultItem, SplFormData } from '../../pages/SinglePieceLookupPage/types';
import { trimObject } from '../../util/AddressUtils';
import { ghApi } from '../DataService';
import { AcsEvent, MailPiece, Scan } from './types';

const getMailDetailsFx = createEffect<{ imb: string; pkgId: string }, MailPiece>(async ({ imb, pkgId }) => {
  return ghApi.get('/spl/mailingDetails', { params: { imb, pkgId } }).then(res => trimObject(res.data) as MailPiece);
});

const getAcsEventsFx = createEffect<
  {
    trackCode: string;
    pkgId: string;
    mailDate: string;
  },
  AcsEvent[]
>(async params => {
  return ghApi.get('/spl/acsEvents', { params }).then(res => res.data.map((acsEvent: AcsEvent) => trimObject(acsEvent) as AcsEvent));
});

const getScanDataFx = createEffect<{ trackCode: string; pkgId: string; date: string }, Scan[]>(async params => {
  return ghApi.get('/spl/scans', { params }).then(res => res.data.map((scan: Scan) => trimObject(scan) as Scan));
});

const getSplResultsFx = createEffect<SplFormData, SplSearchResultItem[]>(async params => {
  return ghApi
    .get('/spl/search', {
      params: {
        ...params,
        origin: false
      }
    })
    .then(res => res.data.map(trimObject));
});

export const $$splService = {
  getMailDetailsFx,
  getAcsEventsFx,
  getScanDataFx,
  getSplResultsFx
};
